import React, { createContext } from 'react';

export const OperacionesContext = createContext();